import React from 'react'
import { useTranslation } from 'react-i18next'

import { useNavigate } from '@lib/react-router-dom'

import { getCampaignResultsPath } from '@pages/RewardsHub/CampaignsHistoryTab'
import { useTradingPoolProgress } from '@pages/RewardsHub/hooks/useTradingPoolProgress'
import { TradingPoolCampaignAboutModal } from '@pages/Traders-Room/Campaign-Results/Trading-Pools/TradingPoolCampaignAbout.modal'

import { useModal } from '@context/ModalsContext'

import { Body1, Caption1, Title1 } from '@ui/Typography'
import { Button } from '@ui/components/Button'
import { ProgressBar } from '@ui/components/ProgressBar'

import { CampaignType } from '@model/CampaignType'
import { TradingPoolTypeDto } from '@model/RewardsHubDashboardDto'

import { Box } from '@shared/components/Box'

import styles from '../TradingPoolProgress.module.scss'

export const TradingPoolActive: React.FC<{ campaign: TradingPoolTypeDto }> = ({ campaign }) => {
  const { percentage, daysRemaining } = useTradingPoolProgress(campaign)
  const { t } = useTranslation()

  const navigate = useNavigate()
  const tradingPoolCampaignAbout = useModal(TradingPoolCampaignAboutModal, {
    campaignId: campaign.campaign.id,
  })

  const onClickNavigate = () => {
    navigate(
      getCampaignResultsPath(
        campaign.campaign.id,
        campaign.tradingAccount.name,
        CampaignType.TradingPool
      ),
      { replace: true }
    )
  }

  return (
    <Box flex direction={'column'} className={styles.tradingPoolItem} p={'x24'} gap={'x16'}>
      <Box flex justify='space-between'>
        <Box flex direction={'column'} gap={'x4'}>
          <Caption1 color={'text-med-em'}>
            {t('RewardsHub.TradingPool.Current Prize Pool')}
          </Caption1>
          <Title1 color={'text-high-em'} semibold>
            ${campaign.currentPrizePool}
          </Title1>
        </Box>
        <Box flex direction={'column'} gap={'x4'} align='flex-end'>
          <Caption1 color={'text-med-em'}>{t('RewardsHub.TradingPool.Draw in')}</Caption1>
          <Title1 color={'text-high-em'} semibold>
            {daysRemaining}
          </Title1>
        </Box>
      </Box>
      <Box flex gap={'x8'}>
        <Box
          flex
          direction={'column'}
          align='flex-start'
          gap={'x8'}
          p={'x8'}
          flexItem={1}
          className={styles.tradingPoolItemCard}
        >
          <Caption1>{t('RewardsHub.TradingPool.Your entries')}</Caption1>
          <Body1 semibold>{campaign.entries}</Body1>
        </Box>

        <Box
          flex
          direction={'column'}
          align='flex-start'
          gap={'x8'}
          p={'x8'}
          flexItem={1}
          className={styles.tradingPoolItemCard}
        >
          <Caption1>{t('RewardsHub.TradingPool.Participants')}</Caption1>
          <Body1 semibold>{campaign.totalParticipants}</Body1>
        </Box>
      </Box>

      <Box flex direction={'column'} gap={'x4'}>
        <ProgressBar color={'red'} percent={percentage} />
        <Box flex gap={'x8'} justify='space-between'>
          <Caption1 color={'text-med-em'}>{t('RewardsHub.TradingPool.Entry progress')}</Caption1>
          <Caption1 color={'text-med-em'}>
            {campaign.progressToNextEntry.toFixed(1) + '/' + campaign.lotsPerEntry.toFixed(1)}
          </Caption1>
        </Box>
      </Box>
      <Box flex gap={'x16'}>
        <Button size={'sm'} onClick={() => tradingPoolCampaignAbout.open()} variant={'secondary'}>
          {t('RewardsHub.Learn More')}
        </Button>
        <Button onClick={onClickNavigate} size={'sm'} variant={'primary'}>
          {t('RewardsHub.TradingPool.View Progress')}
        </Button>
      </Box>
    </Box>
  )
}
